export const ACCEPTED_FILE_SIZE = parseInt(import.meta.env.VITE_FILE_SIZE, 10);
export const ACCEPTED_IMAGE_TYPES = JSON.parse(import.meta.env.VITE_IMAGE_TYPES) as string[];
export const ACCEPTED_FILES_TYPES = JSON.parse(import.meta.env.VITE_FILES_TYPES) as string[];

export const API_URL = import.meta.env.VITE_API_URL as string;
export const API_WEBSOCKET_URL = import.meta.env.VITE_API_WEBSOCKET_URL as string;
